import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Briefcase } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';

const AdminJobListings = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2">Job Listings Management</h1>
          <p className="text-muted-foreground">Manage all job postings (Coming soon)</p>
        </div>

        <Card>
          <CardContent className="p-12 text-center">
            <Briefcase className="w-16 h-16 mx-auto mb-4 text-purple-600" />
            <h3 className="text-xl font-semibold mb-2">GoJobs Module</h3>
            <p className="text-muted-foreground">Job listings management will be available when GoJobs module is enabled.</p>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminJobListings;